import { FC, ReactNode } from "react";
import { useRecoilValue } from "recoil";
import { IfBlock } from "../components/IfBlock";
import { showFloorState } from "../stores";

export const IfShowFloor: FC<{
    children: ReactNode
}> = ({ children }) => {
    const visible = useRecoilValue(showFloorState);
    return <IfBlock visible={visible}>{children}</IfBlock>
}
